/* ============================================================
   ORGAINIC Cart Drawer – gift add + gift enforcement
   - Adds unlocked gifts on click (never automatically)
   - Removes gifts whose threshold is no longer met
   - Threshold basis = cart total AFTER discounts, excluding gifts
   ============================================================ */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function dispatchCartChanged() {
    document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
  }

  /* ---- add gift to cart ---- */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-gift-add]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.disabled) return;

    var card = btn.closest('[data-gift-offer]');
    var select = card.querySelector('[data-gift-variant]');
    var variantId = parseInt(select ? select.value : card.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _free_gift: 'true',
          _gift_threshold: card.dataset.threshold || '0'
        }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        dispatchCartChanged();
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* ---- add upsell product to cart ---- */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-upsell-add]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.disabled) return;

    var card = btn.closest('[data-upsell]');
    var variantId = parseInt(card.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        dispatchCartChanged();
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* ---- discount code field ---- */
  function applyDiscountCode(btn) {
    var wrap = btn.closest('[data-crw-discount]').parentElement;
    var input = wrap.querySelector('.crw-discount__input');
    var msg = wrap.querySelector('[data-crw-discount-msg]');
    var code = (input.value || '').trim();
    if (!code || btn.disabled) return;

    btn.disabled = true;
    msg.hidden = true;

    fetch(root + 'discount/' + encodeURIComponent(code))
      .then(function () {
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({})
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var lc = code.toLowerCase();
        var applied = false;
        (cart.cart_level_discount_applications || []).forEach(function (da) {
          if ((da.title || '').toLowerCase() === lc) applied = true;
        });
        (cart.items || []).forEach(function (item) {
          (item.line_level_discount_allocations || []).forEach(function (da) {
            var t = (da.discount_application && da.discount_application.title) || '';
            if (t.toLowerCase() === lc) applied = true;
          });
        });
        msg.hidden = false;
        if (applied) {
          msg.textContent = (window.orgainicStrings && window.orgainicStrings.codeApplied) || 'Code angewendet.';
          msg.className = 'crw-discount__msg crw-discount__msg--ok';
          input.value = '';
        } else {
          msg.textContent = (window.orgainicStrings && window.orgainicStrings.codeInvalid) || 'Code ungültig oder Bedingungen nicht erfüllt.';
          msg.className = 'crw-discount__msg crw-discount__msg--error';
        }
        btn.disabled = false;
        dispatchCartChanged();
      })
      .catch(function () {
        btn.disabled = false;
        msg.hidden = false;
        msg.textContent = (window.orgainicStrings && window.orgainicStrings.codeCheckFailed) || 'Code konnte nicht geprüft werden.';
        msg.className = 'crw-discount__msg crw-discount__msg--error';
      });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-crw-discount-apply]');
    if (btn) {
      evt.preventDefault();
      applyDiscountCode(btn);
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Enter' && evt.target.classList && evt.target.classList.contains('crw-discount__input')) {
      evt.preventDefault();
      var btn = evt.target.closest('[data-crw-discount]').querySelector('[data-crw-discount-apply]');
      if (btn) applyDiscountCode(btn);
    }
  });

  /* keep the discount field visible above the mobile keyboard */
  document.addEventListener('focusin', function (evt) {
    if (!evt.target.classList || !evt.target.classList.contains('crw-discount__input')) return;
    var input = evt.target;
    setTimeout(function () {
      if (document.activeElement === input) {
        input.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, 350);
  });

  /* ---- drawer quantity/remove clicks: owned exclusively by the theme ----
     Third-party app scripts (e.g. EasyGift via ScriptTag) hijack the
     remove/quantity links inside the drawer (href="javascript:void(0)" +
     their own click handler that can redirect to the cart page). This
     capture-phase handler runs before any element-level app handler, stops
     the event entirely and performs the change itself, so neither a
     hijacked handler nor default link navigation can ever leave the page. */
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('a.cart-item__remove, a.quantity-down, a.quantity-up');
    if (!link || !link.closest('.cart-drawer')) return;
    evt.preventDefault();
    evt.stopPropagation();
    var cf = link.closest('cart-form');
    var item = link.closest('.cart-item');
    if (cf && item && typeof cf.adjustItemQuantity === 'function') {
      if (link.classList.contains('cart-item__remove')) {
        cf.adjustItemQuantity(item, { to: 0 });
      } else if (link.classList.contains('quantity-down')) {
        cf.adjustItemQuantity(item, { decrease: true });
      } else {
        cf.adjustItemQuantity(item, { increase: true });
      }
      return;
    }
    try {
      var href = link.getAttribute('href') || '';
      if (href.indexOf('/cart/change') === -1) return;
      var u = new URL(href, window.location.origin);
      var id = u.searchParams.get('id');
      var qty = parseInt(u.searchParams.get('quantity'), 10);
      if (!id) return;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: isNaN(qty) ? 0 : qty })
      }).then(function (res) {
        if (res.ok) dispatchCartChanged();
      });
    } catch (e) { /* navigation stays prevented */ }
  }, true);

  /* ---- info tooltip toggle ---- */
  document.addEventListener('click', function (evt) {
    var infoBtn = evt.target.closest('[data-crw-info]');
    var openTooltip = document.querySelector('.crw-rewards__tooltip:not([hidden])');
    if (infoBtn) {
      evt.preventDefault();
      var tooltip = infoBtn.closest('.crw-rewards__status').querySelector('.crw-rewards__tooltip');
      if (tooltip) tooltip.hidden = !tooltip.hidden;
    } else if (openTooltip && !evt.target.closest('.crw-rewards__tooltip')) {
      openTooltip.hidden = true;
    }
  });

  /* ---- product-triggered free gift (e.g. bundle LPs -> free shaker) ----
     Config comes from data attributes on the cart drawer section wrapper. */
  function productGiftConfig() {
    var el = document.querySelector('[data-pgift-variant]');
    if (!el) return null;
    var variantId = parseInt(el.dataset.pgiftVariant, 10);
    var triggers = (el.dataset.pgiftTriggers || '')
      .split(',')
      .map(function (s) { return parseInt(s, 10); })
      .filter(Boolean);
    if (!variantId || !triggers.length) return null;
    return { variantId: variantId, triggers: triggers };
  }

  /* ---- enforce gift qualification after every cart change ---- */
  var enforcing = false;
  function enforceGifts() {
    if (enforcing) return;
    fetch(root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var giftsDisabled = !!document.querySelector('[data-gifts-disabled]');
        if (giftsDisabled) {
          var removals = {};
          cart.items.forEach(function (item) {
            if (item.properties && item.properties._free_gift) {
              removals[item.key] = 0;
            }
          });
          if (Object.keys(removals).length === 0) return;
          enforcing = true;
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: removals })
          }).then(function () {
            enforcing = false;
            dispatchCartChanged();
          }).catch(function () {
            enforcing = false;
          });
        }

        var giftsTotal = 0;
        cart.items.forEach(function (item) {
          if (item.properties && item.properties._free_gift) {
            giftsTotal += item.final_line_price;
          }
        });
        var basis = cart.total_price - giftsTotal;

        var pg = productGiftConfig();
        var pgHasTrigger = false;
        var pgGiftLine = null;
        if (pg) {
          cart.items.forEach(function (item) {
            var isGiftLine = item.properties && item.properties._free_gift;
            if (!isGiftLine && pg.triggers.indexOf(item.product_id) !== -1) pgHasTrigger = true;
            if (isGiftLine && item.variant_id === pg.variantId && item.properties._gift_rule === 'product') {
              pgGiftLine = item;
            }
          });
        }

        var updates = {};
        cart.items.forEach(function (item) {
          if (!item.properties || !item.properties._free_gift) return;
          if (item.properties._gift_rule === 'product') return; // handled below
          var threshold = parseInt(item.properties._gift_threshold || '0', 10);
          if (basis < threshold) {
            updates[item.key] = 0; // no longer qualified -> remove
          } else if (item.quantity > 1) {
            updates[item.key] = 1; // gifts are limited to 1
          }
        });

        if (pg && pgGiftLine) {
          if (!pgHasTrigger) {
            updates[pgGiftLine.key] = 0; // trigger product gone -> remove gift
          } else if (pgGiftLine.quantity > 1) {
            updates[pgGiftLine.key] = 1;
          }
        }

        if (pg && pgHasTrigger && !pgGiftLine) {
          enforcing = true;
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: pg.variantId,
              quantity: 1,
              properties: { _free_gift: 'true', _gift_rule: 'product' }
            })
          }).then(function (res) {
            enforcing = false;
            if (res.ok) dispatchCartChanged();
          }).catch(function () {
            enforcing = false;
          });
        }

        if (Object.keys(updates).length === 0) return;

        enforcing = true;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          enforcing = false;
          dispatchCartChanged();
        });
      })
      .catch(function () {
        enforcing = false;
      });
  }

  document.addEventListener('theme:cartchanged', enforceGifts);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceGifts);
  } else {
    enforceGifts();
  }

  /* ---- hide third-party overlays (Klaviyo teaser & co) while the drawer is open ----
     Generic on purpose: anything fixed-positioned with a high z-index that overlaps
     the drawer gets hidden while the drawer is open, no matter which app renders it. */
  var overlayExclude = /iubenda|cc-popup|cart-drawer|floating-header|pageheader|section-cart-drawer|shopify-section/i;
  var overlayObserver = null;
  var drawerOpen = false;

  function isOverlayCandidate(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'TEMPLATE' || tag === 'NOSCRIPT') return false;
    var ident = ((el.className || '') + ' ' + (el.id || '')).toString();
    if (overlayExclude.test(ident)) return false;
    if (el.closest && el.closest('.cart-drawer-modal, [data-section-type="cart-drawer"]')) return false;
    if (el.querySelector && el.querySelector('.cart-drawer-modal')) return false;
    var cs = getComputedStyle(el);
    if (cs.position !== 'fixed') return false;
    if (cs.visibility === 'hidden' || cs.display === 'none') return false;
    var z = parseInt(cs.zIndex || '0', 10) || 0;
    if (z < 1000) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    return true;
  }

  function scanAndHideOverlays() {
    if (!drawerOpen) return;
    var candidates = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      candidates.push(el);
      Array.prototype.forEach.call(el.children || [], function (child) { candidates.push(child); });
    });
    candidates.forEach(function (el) {
      if (isOverlayCandidate(el)) {
        el.setAttribute('data-crw-overlay-hidden', 'true');
        el.style.setProperty('visibility', 'hidden', 'important');
      }
    });
  }

  function restoreOverlays() {
    document.querySelectorAll('[data-crw-overlay-hidden]').forEach(function (el) {
      el.removeAttribute('data-crw-overlay-hidden');
      el.style.removeProperty('visibility');
    });
  }

  document.addEventListener('theme:open-cart-drawer', function () {
    drawerOpen = true;
    document.body.classList.add('crw-drawer-open');
    scanAndHideOverlays();
    setTimeout(scanAndHideOverlays, 600);
    setTimeout(scanAndHideOverlays, 1500);
    if (!overlayObserver) {
      overlayObserver = new MutationObserver(function () { scanAndHideOverlays(); });
    }
    overlayObserver.observe(document.body, { childList: true });
  });
  document.addEventListener('theme:close-cart-drawer', function () {
    drawerOpen = false;
    document.body.classList.remove('crw-drawer-open');
    if (overlayObserver) overlayObserver.disconnect();
    restoreOverlays();
  });

  /* ---- iOS: pin the drawer to the actually visible viewport height ---- */
  function syncDrawerViewportHeight() {
    var popup = document.querySelector('.cart-drawer-modal.cc-popup');
    if (!popup) return;
    if (window.innerWidth > 767 || !window.visualViewport) {
      popup.style.removeProperty('height');
      return;
    }
    popup.style.setProperty('height', Math.round(window.visualViewport.height) + 'px', 'important');
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncDrawerViewportHeight);
  }
  window.addEventListener('orientationchange', function () { setTimeout(syncDrawerViewportHeight, 250); });
  document.addEventListener('theme:open-cart-drawer', syncDrawerViewportHeight);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDrawerViewportHeight);
  } else {
    syncDrawerViewportHeight();
  }

  /* ---- animated progress bar + milestone unlock + confetti ---- */
  var FILL_DURATION = 900;
  var rewardsState = { pct: null, reached: null };

  function confettiBurst(milestone) {
    var zone = milestone.closest('.crw-rewards__track-zone');
    if (!zone) return;
    var host = document.createElement('div');
    host.className = 'crw-confetti';
    host.style.left = milestone.style.left || '50%';
    zone.appendChild(host);
    var colors = ['#7ea865', '#233a28', '#f5de71', '#df5641', '#fffdf6'];
    for (var i = 0; i < 18; i++) {
      var p = document.createElement('span');
      p.style.background = colors[i % colors.length];
      host.appendChild(p);
      var angle = Math.random() * Math.PI * 2;
      var dist = 24 + Math.random() * 42;
      var dx = Math.cos(angle) * dist;
      var dy = Math.sin(angle) * dist - 18;
      p.animate(
        [
          { transform: 'translate(0, 0) rotate(0deg) scale(1)', opacity: 1 },
          { transform: 'translate(' + dx + 'px, ' + (dy + 34) + 'px) rotate(' + (Math.random() * 540 - 270) + 'deg) scale(0.7)', opacity: 0 }
        ],
        { duration: 750 + Math.random() * 500, easing: 'cubic-bezier(.15,.55,.45,1)', fill: 'forwards' }
      );
    }
    setTimeout(function () { host.remove(); }, 1400);
  }

  function syncRewards(animate) {
    var wrap = document.querySelector('[data-merge="rewards-bar"]');
    if (!wrap) return;
    var fill = wrap.querySelector('.crw-rewards__fill');
    if (!fill) {
      rewardsState.pct = null;
      rewardsState.reached = null;
      return;
    }

    var target = parseFloat(fill.dataset.fill || '0');
    var milestones = Array.prototype.slice.call(wrap.querySelectorAll('.crw-milestone'));
    var reachedNow = milestones
      .filter(function (m) { return m.classList.contains('crw-milestone--reached'); })
      .map(function (m) { return m.dataset.th; });

    var prevPct = rewardsState.pct;
    var prevReached = rewardsState.reached;
    rewardsState.pct = target;
    rewardsState.reached = reachedNow;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!animate || prevPct === null || reduceMotion) return;

    var newly = prevReached === null ? [] : milestones.filter(function (m) {
      return m.classList.contains('crw-milestone--reached') && prevReached.indexOf(m.dataset.th) === -1;
    });

    if (Math.abs(prevPct - target) > 0.1) {
      fill.classList.remove('crw-rewards__fill--animating');
      fill.style.width = prevPct + '%';
      void fill.offsetWidth;
      fill.classList.add('crw-rewards__fill--animating');
      fill.style.width = target + '%';
    }

    newly.forEach(function (m) {
      m.classList.remove('crw-milestone--reached');
      m.classList.add('crw-milestone--pending');
      var pos = parseFloat(m.dataset.pos || '0');
      var progressFraction = target > prevPct ? (pos - prevPct) / (target - prevPct) : 1;
      progressFraction = Math.max(0, Math.min(1, progressFraction));
      setTimeout(function () {
        m.classList.remove('crw-milestone--pending');
        m.classList.add('crw-milestone--reached', 'crw-milestone--pop');
        confettiBurst(m);
        setTimeout(function () { m.classList.remove('crw-milestone--pop'); }, 650);
      }, Math.round(FILL_DURATION * progressFraction));
    });
  }

  function initRewards() {
    var wrap = document.querySelector('[data-merge="rewards-bar"]');
    if (!wrap) return;
    syncRewards(false);
    new MutationObserver(function () {
      requestAnimationFrame(function () { syncRewards(true); });
    }).observe(wrap, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRewards);
  } else {
    initRewards();
  }
})();
